export function filterEmptyAssistantMessages<
  T extends { role: string; parts: unknown[] },
>(messages: T[]): T[] {
  return messages.filter(
    (message) => message.role !== "assistant" || message.parts.length > 0,
  );
}
